<div class="access-denied">
  <div class="container">
    <h1>Access Denied</h1>
    <p>You don't have permission to access this page.</p>
    <p>Please contact the system administrator for assistance.</p>
  </div>
</div>
